import { library } from '@fortawesome/fontawesome-svg-core'
import { faAws, faCss3, faDocker, faGit, faGithub, faHtml5, faJediOrder, faJs, faLinkedin, faNode, faPhp, faSass, faStripe, faSymfony, faTwitter, faTypo3, faVuejs } from '@fortawesome/free-brands-svg-icons'

import { faChalkboardTeacher, faCloud, faCode, faEnvelope } from '@fortawesome/free-solid-svg-icons'

// brands
library.add(faTypo3, faSass, faAws, faDocker, faCss3, faGit, faHtml5, faSymfony, faJediOrder, faJs, faNode, faPhp, faSass, faStripe, faVuejs)

// social
library.add(faLinkedin, faGithub, faTwitter)

// other
library.add(faEnvelope, faCode, faCloud, faChalkboardTeacher)
